export default function getQrCode(Uuid) {
    return (
      process.env.VUE_APP_URL + "" + this.$router.resolve({ name: "qr_verify", params: { uuid: Uuid } }).href
    );
  }